<template>
  <div class="content-body">
    <section class="flexbox-container">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="">
          <div class="text-center mb-1">
            <img src="images/logo/logo.png" alt="branding logo">
          </div>
          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
            <div class="card-content">
              <div class="card-body">
                <form class="form-horizontal" id="login-form" v-on:submit.prevent="update_password">
                  <fieldset class="form-group position-relative has-icon-left">
                    <input type="text" class="form-control" id="username" placeholder="Username" required v-model="username" readonly>
                    <div class="form-control-position">
                      <i class="ft-user"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left">
                    <input type="password" class="form-control" id="password" placeholder="Enter Current Password" required v-model="password">
                    <div class="form-control-position">
                      <i class="ft-lock"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left">
                    <input type="password" class="form-control" id="password" placeholder="Enter New Password" required v-model="new_password">
                    <div class="form-control-position">
                      <i class="ft-lock"></i>
                    </div>
                  </fieldset>

                  <div class="alert alert-danger mb-2" role="alert" v-if="errorMsg">
                    <strong>Oh snap!</strong> {{errorMsg}}
                  </div>

                  <div class="form-group text-center">
                    <button type="submit" class="btn btn-block btn-glow btn-primary">Update Password</button>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12 col-12 text-center">
                      <a href="https://admin.medicater.co.za/login/forgot_password" class="card-link" target="_blank" v-if="platformId == 'browser'">Forgot Password?</a>

                      <a href="#" class="card-link" target="_blank" v-if="platformId != 'browser'" v-on:click="ForgotP()">Forgot Password?</a>
                    </div>
                  </div>

                  <p class="card-subtitle text-muted my-1"><span>Don't have an account ? <router-link to="/register" class="card-link">Sign Up</router-link></span></p>
                </form>
              </div>
            </div>
          </div>
          <div class="text-right">
            <br /><small style="color:#FFF">Version <strong>{{version}}</strong></small>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'login',
  data: function () {
    return {
      username: window.localStorage.getItem('username'),
      password: '',
      new_password: '',
      errorMsg: '',
      version: version,
      platformId: cordova.platformId
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AuthLayout')
     if(cordova.platformId != "browser"){
   window.plugins.imeiGetter.get(function(imei){
       console.log(imei);
        window.localStorage.setItem('imei',device.imei)
    }, function(err){
       console.error("Oh..", err);
        window.localStorage.setItem('imei','')
    });

    window.localStorage.setItem('uuid',device.uuid)
    window.localStorage.setItem('version',device.version)
    window.localStorage.setItem('device_name',device.manufacturer+" "+device.model)
 }
 
  },
  methods: {
    ForgotP: function () {
      var url = "https://admin.medicater.co.za/login/forgot_password"
      cordova.InAppBrowser.open(url, '_blank');
    },
    update_password: function () {
      var that = this
      that.errorMsg = ''

        var data = {
          username: this.username,
          password: this.password,
          new_password: this.new_password,
          deviceId: window.localStorage.getItem('deviceId'),
          imei: window.localStorage.getItem('imei'),
          uuid: window.localStorage.getItem('uuid'),
          device_name: window.localStorage.getItem('device_name'),
          os_version: window.localStorage.getItem('version'),
          os:cordova.platformId
        }

        $.ajax({
          url: this.$config.apiUrl + 'basic/update_password',
          type: 'post',
          data: JSON.stringify(data),
          success: function (data) {
            if (typeof data.success !== 'undefined' && data.success === true) {
              window.localStorage.setItem('username', that.username)
              window.localStorage.setItem('password', that.password)
              
              that.login()
            } else {
              //var meta = JSON.parse(data.responseText)
              that.showError(data.message)
            }
          },
          error: function (data) {
            // var meta = JSON.parse(data.responseText)
            that.showError(data.message)
          }
        })

    },
    login: function () {
      var that = this
      that.errorMsg = ''

        var data = {
          username: this.username,
          password: this.new_password,
          deviceId: window.localStorage.getItem('deviceId'),
          imei: window.localStorage.getItem('imei'),
          uuid: window.localStorage.getItem('uuid'),
          device_name: window.localStorage.getItem('device_name'),
          os_version: window.localStorage.getItem('version'),
          os:cordova.platformId
        }

        if(cordova.platformId != "browser"){
            data = {
              username: this.username,
              password: this.password,
              deviceId: window.localStorage.getItem('deviceId'),
              imei: window.localStorage.getItem('imei'),
              uuid: device.uuid,
              device_name: device.manufacturer+" "+device.model,
              os_version: device.version,
              os:cordova.platformId
            }

        }

        $.ajax({
          url: this.$config.apiUrl + 'basic/login',
          type: 'post',
          data: JSON.stringify(data),
          success: function (data) {
            if (typeof data.success !== 'undefined' && data.success === true) {
              window.localStorage.setItem('user', JSON.stringify(data.data))
              window.localStorage.setItem('token', data.meta.token)
              window.localStorage.setItem('username', that.username)
              window.localStorage.setItem('password', that.password)
              window.localStorage.setItem('review_questions', JSON.stringify(data.data.review_questions))
              if(data.data.is_first_signup == 'Y'){
                that.$router.push('/updatePassword')
                return false
              }
              that.$router.push('/')
            } else {
              var meta = JSON.parse(data.responseText)
              that.showError(meta.meta.reason)
            }
          },
          error: function (data) {
            var meta = JSON.parse(data.responseText)
            that.showError(meta.meta.reason)
          }
        })

    },
    showError: function (message) {
      this.errorMsg = message
    }
  }
}
</script>
